import type { StatsResponse } from "../api";
import { formatDuration } from "../format";

interface StatsSummaryProps {
  stats: StatsResponse;
}

export function StatsSummary({ stats }: StatsSummaryProps) {
  const tiles: { label: string; value: string }[] = [
    { label: "Fasts", value: String(stats.count) },
    { label: "Avg", value: stats.count > 0 ? formatDuration(stats.average_seconds) : "—" },
    { label: "Longest", value: stats.count > 0 ? formatDuration(stats.longest_seconds) : "—" },
    { label: "Met", value: `${stats.target_met_count}/${stats.count}` },
    { label: "Rate", value: `${Math.round(stats.target_met_percent)}%` },
    { label: "Streak", value: `${stats.current_streak}d` }
  ];

  return (
    <div className="metric-grid">
      {tiles.map((tile) => (
        <div className="metric-tile" key={tile.label}>
          <span className="label">{tile.label}</span>
          <span className="value num">{tile.value}</span>
        </div>
      ))}
    </div>
  );
}
